import { Select, Button, NumberInput } from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useEventStore } from "../../../store/events.store";
import { useDrawerStore } from "../../../store/dashboard.store";
import { EventTypes } from "../../../models/events";
import dayjs from "dayjs";


const AddEvent = () => {
    const addEvent = useEventStore(state => state.addEvent);
    const popPage  = useDrawerStore(state => state.popPage);
    
    const form = useForm({
        initialValues: {
            type: EventTypes.GENERAL,
            date: dayjs().endOf('week').add(1, 'day').set('hour', 12).set('minutes', 0).toDate(),
            limit: 10,
        },
        validate: {
            type: (value: string) => (value ? null : 'Type is required'),
            date: (value: Date) => (value ? null : 'Date is required'),
            limit: (value: number) => (value ? null : 'Limit is required'),
        },
    })
    return (
        <form onSubmit={form.onSubmit(async (values) => { 
            await addEvent({
                type: values.type,
                date: dayjs(values.date).toDate().toISOString(),
                limit: values.limit,
            }); 
            popPage();
        })}>
            <Select
                label="Type"
                required
                placeholder="General"
                data={[EventTypes.GENERAL, EventTypes.BEHAVIOR]}
                {...form.getInputProps('type')}
            />
            <DateTimePicker
                label="Date"
                required
                valueFormat="MMM DD YYYY hh:mm a"
                {...form.getInputProps('date')}
            />
            <NumberInput
                label="Limit"
                required
                placeholder="10"
                {...form.getInputProps('limit')}
            />
            <br/>
            <Button type="submit">Submit</Button>
        </form>
    );
};

export default AddEvent;
